<div flexLayout="column" flexLayoutAlign="start stretch">
  @if ((ready$ | async) === true) {
<ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{
    model: model$ | async
  }">
    </ng-container>
  }
</div>

<ng-template #template let-model="model">
  <div mat-dialog-title>
    Add Tag
  </div>
  <formly-form [form]="formGroup" [fields]="fields" [options]="options" [model]="model">
  </formly-form>
  <mat-dialog-actions flexLayoutAlign="end center">
    <button type="button" mat-flat-button (click)="onCancel()">Cancel</button>
    <button type="button" mat-raised-button (click)="onSave()" color="primary" [disabled]="formGroup.invalid">
      Save
    </button>
  </mat-dialog-actions>
</ng-template>
